<script setup lang="ts">
import { useQuizStore } from '../../../../stores';
import Iframe from '../../../General/Iframe.vue';

const quizStore = useQuizStore()
</script>

<template>
    <div class="h-full flex flex-col items-center justify-evenly overflow-auto">
        <Iframe v-if="quizStore.quiz.url" :src="quizStore.quiz.url"></Iframe>
    </div>
</template>